import { parse } from './urlHelpers';

/**
 * URL fingerprint without `sort` or `page` — same fingerprint means the visible
 * result set is the same just reordered/paginated. Used to keep previous results
 * on screen while the server re-sorts.
 */
export const discoveryFilterFingerprint = locationSearch => {
  const q = parse(locationSearch || '', {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  const copy = { ...q };
  delete copy.page;
  delete copy.sort;
  return JSON.stringify(copy);
};
